import Breabcrumbs from 'vue-2-breadcrumbs';

export default ({ Vue }) => {
  Vue.use(Breabcrumbs, {
    template: '<nav v-if="$breadcrumbs.length > 1" aria-label="">\n' +
        '            <ol class="breadcrumb">\n' +
        '                <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" class="breadcrumb-item active" aria-current="page">\n' +
        '                    <router-link :to="{ path: getPath(crumb) }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
        '                </li>\n' +
        '            </ol>\n' +
        '        </nav>',
  });
};



// WEBPACK FOOTER //
// ./src/plugins/vue-breadcrumbs.js